<template>
  <el-row>
    <el-col :span="5">
      <basic-container>
        <avue-tree :option="treeOption" :data="treeData" @node-click="nodeClick" />
      </basic-container>
    </el-col>
    <el-col :span="19">
      <basic-container>
        <avue-crud
          :option="option"
          :table-loading="loading"
          :data="data"
          :page="page"
          :permission="permissionList"
          :before-open="beforeOpen"
          v-model="form"
          ref="crud"
          @row-update="rowUpdate"
          @row-save="rowSave"
          @row-del="rowDel"
          @search-change="searchChange"
          @search-reset="searchReset"
          @selection-change="selectionChange"
          @current-change="currentChange"
          @size-change="sizeChange"
          @refresh-change="onLoad"
          @on-load="onLoad"
        >
          <template slot="menuLeft">
            <el-button
              type="danger"
              size="small"
              icon="el-icon-delete"
              plain
              v-if="permission.doordevice_delete"
              @click="handleDelete"
              >删 除
            </el-button>
          </template>
          <template slot-scope="scope" slot="menu">
            <el-button
              type="text"
              size="small"
              icon="el-icon-s-custom"
              @click="openAuthDialog(scope.row)"
              >授权
            </el-button>
          </template>
          <template slot="onlineStatus" slot-scope="scope">
            <el-tag :class="'device-status-class-' + scope.row.onlineStatus"
              >{{ scope.row.onlineStatus }}
            </el-tag>
          </template>
        </avue-crud>
        <el-dialog
          title="授权"
          append-to-body
          :visible.sync="authFlag"
          width="350px"
          @closed="closedDialog()"
        >
          <template slot-scope="scope">
            <el-tree
              v-loading="flishFlag"
              element-loading-text="加载中"
              class="org-tree"
              :expand-on-click-node="false"
              :data="propertyList"
              :check-on-click-node="true"
              v-show="ishowTree"
              show-checkbox
              ref="tree"
              :check-strictly="true"
              highlight-current
              node-key="key"
              :default-expand-all="true"
              :default-checked-keys="propertyIds"
              @check-change="currentchange"
              @check="handleCheck"
              @node-click="handleNodeClick"
              :props="defaultProps"
            >
            </el-tree>
          </template>
          <span slot="footer" class="dialog-footer">
            <el-button @click="authFlag = false">取 消</el-button>
            <el-button type="primary" @click="submitAuth">确 定</el-button>
          </span>
        </el-dialog>
      </basic-container>
    </el-col>
  </el-row>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  getTreeList,
  getBasePropertyTree,
  auth,
  getAuthInfo,
} from '@/api/v4ward/door/device/doordevice';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      searchOrgId: '',
      input: [],
      ishowTree: false,
      propertyList: [],
      propertyIds: '',
      defaultProps: {
        label: 'objectFullName',
        value: 'value',
        children: 'children',
      },
      organCodes: [],
      projectOrg: '',
      restaurants: [],
      flishFlag: true,
      state: '',
      doorBaseInfoList: [],
      query: {},
      authFlag: false,
      doorDeviceIdTemp: '',
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      doorAreaTempList: [],
      treeData: [],
      treeNodeId: '',
      treeOption: {
        addBtn: false,
        menu: false,
        size: 'small',
        props: {
          labelText: '标题',
          label: 'title',
          value: 'value',
          children: 'children',
        },
      },
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        align: 'center',
        searchShow: false,
        searchMenuSpan: 6,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: true,
        selection: false,
        dialogClickModal: false,
        menuWidth: 190,
        labelWidth: 110,
        dialogWidth: '40%',
        columnBtn: false,
        column: [
          {
            label: '小区名称',
            prop: 'communityName',
            display: false,
          },
          {
            label: '区域名称',
            prop: 'areaName',
            display: false,
          },
          {
            label: '小区名称',
            prop: 'communityId',
            dataType: 'string',
            type: 'select',
            hide: true,
            editDisabled: true,
            search: true,
            searchSpan: 8,
            dicUrl: '/api/door/device/getTreeList',
            props: {
              label: 'title',
              value: 'value',
            },
            rules: [
              {
                required: true,
                message: '请选择小区',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '区域名称',
            prop: 'doorAreaId',
            dataType: 'string',
            type: 'select',
            hide: true,
            dicData: [],
            props: {
              label: 'title',
              value: 'value',
            },
            rules: [
              {
                required: true,
                message: '请选择区域',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '设备品牌',
            prop: 'doorDeviceBrand',
            type: 'tree',
            editDisabled: true,
            addDisabled: true,
            dicUrl: '/api/blade-system/dict/dictionary?code=door_device_brand',
            props: { label: 'dictValue', value: 'dictKey' },
            dataType: 'number',
            rules: [
              {
                required: true,
                message: '请输入设备品牌',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '设备名称',
            prop: 'deviceName',
            rules: [
              {
                required: true,
                message: '请输入设备名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '设备IP',
            prop: 'deviceIp',
            width: 100,
            rules: [
              {
                pattern: /^((?:(?:25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(?:25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d))))$/,
                message: 'IP格式错误',
              },
            ],
          },
          {
            label: '设备Id',
            prop: 'deviceId',
          },
          {
            label: '在线状态',
            prop: 'onlineStatus',
            width: 80,
            slot: true,
          },
          {
            label: '创建时间',
            prop: 'createTime',
            display: false,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.doordevice_add, true),
        viewBtn: this.vaildData(this.permission.doordevice_view, false),
        delBtn: this.vaildData(this.permission.doordevice_delete, true),
        editBtn: this.vaildData(this.permission.doordevice_edit, true),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  watch: {
    'form.communityId'() {
      if (this.form.communityId != '') {
        let communityList = this.treeData;
        //循环遍历，匹配所选小区获得小区下的区域数据
        for (let i = 0; i < communityList.length; i++) {
          //定义区域id临时变量
          let communityIdTemp = communityList[i].communityId;
          //获取所选区域下的区域数据
          if (communityIdTemp == this.form.communityId) {
            const column = this.findObject(this.option.column, 'doorAreaId');
            column.dicData = communityList[i].children;
            this.doorAreaTempList = column.dicData;
          }
        }
      } else {
        this.form.doorAreaId = '';
        this.doorAreaTempList = [];
        this.form.doorDeviceBrand = '';
      }
    },
    'form.doorAreaId'() {
      if (this.form.doorAreaId !== '') {
        let doorAreaTempList = this.doorAreaTempList;
        //循环遍历，匹配所选小区获得小区下的区域数据
        for (let i = 0; i < doorAreaTempList.length; i++) {
          //定义区域id临时变量
          let doorAreaIdTemp = doorAreaTempList[i].doorAreaId;
          //获取所选区域下的区域数据
          if (doorAreaIdTemp == this.form.doorAreaId) {
            this.form.doorDeviceBrand = doorAreaTempList[i].doorDeviceBrand;
          }
        }
      } else {
        this.form.doorDeviceBrand = '';
      }
    },
  },
  mounted() {
    this.initTreeList();
  },
  methods: {
    nodeClick(data) {
      this.treeNodeId = data.value;
      this.page.currentPage = 1;
      this.onLoad(this.page);
    },
    initTreeList() {
      getTreeList().then((res) => {
        this.treeData = res.data;
      });
    },
    submitAuth() {
      var propertyIds = this.propertyIds.toString();
      auth({ doorDeviceId: this.doorDeviceIdTemp, autType: 2, propertyIds: propertyIds }).then(
        () => {
          this.authFlag = false;
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
          this.onLoad();
        }
      );
    },
    getCheckNodeDown(tmpKey, currentKey) {
      let parentId = this.$refs.tree.getNode(tmpKey).data.parentId;
      let nodeInfo = this.$refs.tree.getNode(tmpKey);
      if (parentId == 0) {
        return true;
      }
      if (this.$refs.tree.getNode(parentId).checked) {
        this.$refs.tree.getNode(currentKey).checked = false;
        this.$message.warning('对父节点授权时，无需选择子节点');
        return false;
      }
      this.getCheckNodeDown(parentId, currentKey);
    },
    getCheckNodeUp(childNodes, tmpKey, currentKey) {
      childNodes =
        this.$refs.tree.getNode(tmpKey).childNodes.length > 0
          ? this.$refs.tree.getNode(tmpKey).childNodes
          : [];
      if (childNodes.length == 0) {
        return;
      }
      for (let item of childNodes) {
        if (item.checked) {
          this.$refs.tree.getNode(currentKey).checked = false;
          this.$message.warning('对子节点授权时，无需选择父节点');
        } else if (item.childNodes.length > 0) {
          this.getCheckNodeUp(item.childNodes, item.data.key, currentKey);
        }
      }
    },
    handleCheck(data, nodes, e) {
      let key = data.key;
      let result = this.getCheckNodeDown(key, key);
      let result_ = this.getCheckNodeUp([], key, key);

      let self = this;
      self.$nextTick(() => {
        let nodesList = self.$refs.tree.getCheckedKeys();
        self.propertyIds = nodesList.join(',');
      });
    },
    //树型点击
    projectOrgFalse() {
      this.ishowTree = false;
    },
    handleNodeClick(data, node, com) {},
    getOrgList(node, resolve) {
      let that = this;
      //等于0表示根节点
      if (node.level == 0) {
        resolve(FirstRootNodeData);
        //直接返回
        return;
      } else {
        resolve(LeafNodeData);
        return;
      }
    },
    projectOrgFun(e) {
      let that = this;
      if (this.ishowTree) {
        this.ishowTree = false;
      } else {
        this.ishowTree = true;
      } //第一种方式:点击其他区域, 消失树

      document.onclick = function () {
        that.ishowTree = false;
      };
      e.stopPropagation(); //阻止冒泡 //离开区域的时候树消失
    },

    openAuthDialog(row) {
      //先清空数据
      this.propertyIds = [];
      this.doorDeviceIdTemp = '';
      this.authFlag = true;
      this.ishowTree = true;
      this.doorDeviceIdTemp = row.id;
      let communityId = row.communityId;
      getBasePropertyTree(communityId).then((res) => {
        this.propertyList = res.data;
        this.flishFlag = false;
      });
      getAuthInfo({ id: row.id, authType: 2 }).then((res) => {
        this.propertyIds = res.data;
      });
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(
        Object.assign(
          { current: page.currentPage, size: page.pageSize, treeNodeId: this.treeNodeId },
          this.query
        )
      ).then(({ data }) => {
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
      });
    },
    closedDialog() {
      this.propertyList = [];
      this.flishFlag = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-tree {
  cursor: default;
  background: #fff;
  color: #606266;
  z-index: 100;
  border: 1px solid #dcdfe6;
  border-radius: 5px;
}

.org-tree {
  height: 400px;
  overflow: auto;
}

.device-status-class-ON {
  width: 54px;
  background-color: #00d200;
  color: #000000;
}
.device-status-class-OFF {
  width: 54px;
  background-color: #ff0000;
  color: #000000;
}
</style>
